import { render, staticRenderFns } from "./YouthFamilyAuth.vue?vue&type=template&id=d555a41e&scoped=true&"
import script from "./YouthFamilyAuth.vue?vue&type=script&lang=js&"
export * from "./YouthFamilyAuth.vue?vue&type=script&lang=js&"
import style0 from "./YouthFamilyAuth.vue?vue&type=style&index=0&id=d555a41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d555a41e",
  null
  
)

export default component.exports